/** Shared 64-grid geometry for the shell and build-time PWA renderer. */
export type Point = readonly [number, number];
export const MARK_RING = { cx: 32, cy: 14, radius: 4, width: 4.5 };

function quadratic(a: Point, control: Point, b: Point): Point[] {
  return Array.from({ length: 33 }, (_, i) => {
    const t = i / 32;
    const u = 1 - t;
    return [u * u * a[0] + 2 * u * t * control[0] + t * t * b[0],
      u * u * a[1] + 2 * u * t * control[1] + t * t * b[1]];
  });
}

export const MARK_STROKES: { d: string; width: number; points: Point[] }[] = [
  { d: 'M32 20 V45', width: 5.5, points: [[32, 20], [32, 45]] },
  { d: 'M22 26 H42', width: 5.5, points: [[22, 26], [42, 26]] },
  { d: 'M21 33 Q21 47 32 47 Q43 47 43 33', width: 5.5,
    points: [...quadratic([21, 33], [21, 47], [32, 47]),
      ...quadratic([32, 47], [43, 47], [43, 33]).slice(1)] },
  { d: 'M17 39 L21 33', width: 5.5, points: [[17, 39], [21, 33]] },
  { d: 'M47 39 L43 33', width: 5.5, points: [[47, 39], [43, 33]] },
];
// Inset from the arms so the hull remains separate at favicon sizes.
export const MARK_HULL: Point[] = [[26, 35], [37, 35], [38.5, 37], [36.5, 39.5], [28.5, 39.5]];
export const MARK_HULL_PATH = `M${MARK_HULL.map(([x, y]) => `${x} ${y}`).join(' L')} Z`;
